/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { SymbolNodeDependencies } from './dependenciesSymbolNode.generated';
import { createFunctionNode } from '../../factoriesAny.js';
export var FunctionNodeDependencies = {
  NodeDependencies: NodeDependencies,
  SymbolNodeDependencies: SymbolNodeDependencies,
  createFunctionNode: createFunctionNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFunctionNode.generated.js
// module id = 179
// module chunks = 0